<script>
import headNav from "../components/headNav.vue";
import {register} from "../api/api";
import router from "../router";
import {edit} from "../api/api";
import {mapGetters} from "vuex";

export default {
  name: "login",
  components:{headNav},
  computed:{
    ...mapGetters(['userInfo'])
  },
  data(){
    return{
      nickname:'',
      email:'',
      password:'',
      imageUrl: '',
      url:'',
      phone:null,
      device_key:''

    }
  },
  mounted() {
    this.nickname = this.userInfo.name
    this.email = this.userInfo.email
    this.phone = this.userInfo.phone
    this.imageUrl = this.userInfo.avatar
  },
  methods:{
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log(this.imageUrl,'打印imageUrl')
      console.log(res,"打印res")
      console.log(file,"打印file")
      this.url = `http://jk1003.qdytcy.com${res.url}`
    },
    go(name){
      router.push(
        {
          name
        }
      )
    },
    submit(){
      if(this.nickname.trim() == ''){
        this.mes('nickname cannot be empty','warning')
        return
      }
      if(this.phone.trim() == ''){
        this.mes('phone cannot be empty','warning')
        return
      }
      let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if(!reg.test(this.email) || this.email.trim() == ''){
        this.mes('Email is empty or incorrect','warning')
        return
      }
      edit({
        id:this.userInfo.id,
        nickname:this.nickname,
        email:this.email,
        avatar:this.url,
        phone:this.phone,
        device_key:this.device_key,
      }).then( res => {
        console.log(res,"打印res")
        if(res.data.status == 200){
          this.mes(res.data.message,'success')
          this.$store.dispatch('setUserInfo', res.data.data)
          setTimeout(() => {
            this.go('profile')
          },1000)
        }else {
          this.mes(res.data.message,'error')
        }
      })
    },
    mes(message,type){
      this.$message({
        message,
        type
      });
    }
  }
}
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <section class="section">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-6">
            <div class="shadow rounded p-5 bg-white">
              <div class="row">
                <div class="col-12 mb-4">
                  <h4>Edit information</h4>
                </div>
                <div class="col-lg-12">
                  <div class="contact-form">
                      <div style="margin-bottom: 20px">
                        <div>avatar</div>
                        <el-upload
                          class="avatar-uploader"
                          action="http://jk1003.qdytcy.com/api/user/upload"
                          :show-file-list="false"
                          :on-success="handleAvatarSuccess">
                          <img v-if="imageUrl" :src="imageUrl" class="avatar" id="aaa">
                          <i v-else style="border: 1px solid #cccccc;" class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                      <div class="form-group mb-4 pb-2">
                        <label for="exampleFormControlInput1" class="form-label">nickname</label>
                        <input v-model="nickname" class="form-control shadow-none" >
                      </div>
                      <div class="form-group mb-4 pb-2">
                        <label for="exampleFormControlInput1" class="form-label">phone</label>
                        <input v-model="phone" type="number" class="form-control shadow-none" >
                      </div>
                      <div class="form-group mb-4 pb-2">
                        <label for="exampleFormControlInput1" class="form-label">Email</label>
                        <input v-model="email" type="email" class="form-control shadow-none">
                      </div>
                      <div class="form-group mb-4 pb-2">
                        <label for="exampleFormControlInput1" class="form-label">device_key</label>
                        <input v-model="device_key" class="form-control shadow-none">
                      </div>
                      <button class="btn btn-primary w-100" @click="submit()">submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
@import "../../css/style.css";
.register:hover{
  color:#2080E4;
  cursor: pointer;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
  border: 1px solid #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/view/edit.vue